import { SafetyAdvisoryEmail } from '@/emails/SafetyAdvisory'

export default function EmailPreviewPage() {
    return (
        <div className="min-h-screen bg-background py-12">
            <div className="mx-auto max-w-3xl px-4">
                <div className="mb-8 text-center">
                    <h1 className="text-3xl font-bold text-foreground">Email Templates</h1>
                    <p className="mt-2 text-muted-foreground">Preview production email templates</p>
                </div>

                <div className="rounded-xl border border-border bg-card shadow-lg overflow-hidden">
                    <div className="flex items-center gap-2 px-4 py-3 border-b border-border bg-muted/30">
                        <div className="flex gap-1.5">
                            <div className="w-3 h-3 rounded-full bg-red-400" />
                            <div className="w-3 h-3 rounded-full bg-yellow-400" />
                            <div className="w-3 h-3 rounded-full bg-green-400" />
                        </div>
                        <span className="text-xs text-muted-foreground ml-2 font-mono">SafetyAdvisory.tsx</span>
                    </div>
                    <div className="p-0">
                        <SafetyAdvisoryEmail />
                    </div>
                </div>
            </div>
        </div>
    )
}
